<template>
  <el-select filterable class="select-corp" size="mini" @change="changeCode" v-model="id" placeholder="选择购方单位">
    <el-option style="color:red" label="+新增" value="add"></el-option>
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
  <add-buyer @success="addSuccess" ref="addBuyer"></add-buyer>
</template>
<script>
// <invoice-type v-model:code="temp.fplx"></invoice-type>
import { getCorpCustomerList } from "@/api/ea";
export default {
  name: 'corpghdwComponent',
  props: {
    name: '',
  },
  data() {
    return {
      id: "",
      listQuery: {
        comId: this.$store.getters['user/comInfo'].id*1,
      },
      list: [],
    }
  },
  created () {
    this.getList()
  },
  watch: {
    name(){
      if(!this.name){
        this.id = ""
      }
    },
  },
  methods: {
    addSuccess(e){
      this.getList()
      this.id = e[0].id
      this.$emit('update:name', e[0].name)
      this.$emit('success', e[0])
    },
    changeCode(){
      if(this.id == 'add'){
        this.$refs.addBuyer.form = {
          comTax_no:this.$store.getters['user/comInfo'].tax_no,
          companyName:this.$store.getters['user/comInfo'].name,
          comId:this.$store.getters['user/comInfo'].id
        }
        this.$refs.addBuyer.dialogVisible = true
        //清空
        this.id = ""
        this.$emit('update:name', "")
        this.$emit('success', {})
        return
      }
      let infos = this.list.filter(v=>{return this.id == v.id})
      if(infos.length == 1){
        this.$emit('update:id', this.id)
        this.$emit('update:name', infos[0].name)
        this.$emit('success', infos[0])
      }
    },
    getList(){
      getCorpCustomerList(this.listQuery).then(res=>{
        if(res.data.data.list){
          this.list = res.data.data.list
          this.list.map(v=>{
            if(v.name == this.name){
              this.id = v.id
            }
          })
        }
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.select-corp{
  width: 100%;
}
</style>
